import icons from 'url:../../img/icons.svg';

export default class view {
  _data;

  render(data, render = true) {
    if (!data || (Array.isArray(data) && data.length === 0))
      return this.renderError();

    this._data = data;
    const htmlCode = this._generateMarkup();

    if (!render) return htmlCode;

    this._clear();
    this._parentEl.insertAdjacentHTML(`afterbegin`, htmlCode);
  }

  update(data) {
    this._data = data;
    const newHtmlCode = this._generateMarkup();

    const newDom = document.createRange().createContextualFragment(newHtmlCode);

    const newDomElements = Array.from(newDom.querySelectorAll('*'));
    const currDomElements = Array.from(this._parentEl.querySelectorAll('*'));

    newDomElements.forEach((newElement, idx) => {
      const currentElement = currDomElements[idx];

      if (
        !newElement.isEqualNode(currentElement) &&
        newElement.firstChild?.nodeValue.trim() !== ''
      ) {
        currentElement.textContent = newElement.textContent;
      }

      if (!newElement.isEqualNode(currentElement)) {
        Array.from(newElement.attributes).forEach(attr =>
          currentElement.setAttribute(attr.name, attr.value)
        );
      }
    });
  }

  _clear() {
    this._parentEl.innerHTML = '';
  }

  renderSpinner() {
    const htmlCode = `<div class="spinner">
      <svg>
        <use href="${icons}#icon-loader"></use>
      </svg>
    </div>`;

    this._clear();
    this._parentEl.insertAdjacentHTML('afterbegin', htmlCode);
  }

  renderError(message = this._errorMessage) {
    const htmlCode = `<div class="error">
      <div>
      <svg>
      <use href="${icons}#icon-alert-triangle"></use>
      </svg>
      </div>
      <p>${message}</p>
      </div>`;

    this._clear();
    this._parentEl.insertAdjacentHTML('afterbegin', htmlCode);
  }

  renderMessage(message = this._message) {
    const htmlCode = `<div class="message">
              <div>
                <svg>
                  <use href="${icons}#icon-smile"></use>
                </svg>
              </div>
              <p>${message}</p>
            </div>`;

    this._clear();
    this._parentEl.insertAdjacentHTML('afterbegin', htmlCode);
  }
}
